package org.ksdfv.thelema.mesh

import org.ksdfv.thelema.data.IByteData

interface IMeshProvider {
    fun mesh(): IMesh
    fun vertexBuffer(bytes: IByteData, vertexInputs: IVertexInputs, initGpuObjects: Boolean = true): IVertexBuffer
    fun indexBuffer(bytes: IByteData, type: Int, initGpuObjects: Boolean = true): IIndexBufferObject
    fun vertexInputs(vararg inputs: VertexInput): IVertexInputs
    fun vertexInput(size: Int, name: String, type: Int, normalized: Boolean): IVertexInput
    fun screenQuad(): IScreenQuad
}
